import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api';

// Async thunk for fetching step tracker data
export const fetchStepTrackerData = createAsyncThunk(
  'stepTracker/fetchStepTrackerData',
  async (filters = {}) => {
    const response = await api.post(
      `${process.env.REACT_APP_API_BASE_URL}/customer/get-step-tracker-graph-data`,
      filters
    );
    return response.data.data;
  }
);

// Async thunk for deleting step entry
export const deleteStepEntry = createAsyncThunk(
  'stepTracker/deleteStepEntry',
  async (id) => {
    const response = await api.delete(`${process.env.REACT_APP_API_BASE_URL}/customer/delete-steps/${id}`);
    return response.data; // Assume the API returns the updated data
  }
);

export const addStep = createAsyncThunk(
  'stepTracker/addStep',
  async (stepData, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('date', stepData.date);
      formData.append('steps', stepData.step);

      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/customer/add-steps`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for fetching previous week's average steps
export const fetchAverageStepsData = createAsyncThunk(
  'weightTracker/fetchAverageStepsData',
  async (filters = {}) => {
    const response = await api.post(
      '${process.env.REACT_APP_API_BASE_URL}/customer/previous-weeks-average-steps',
      filters
    );
    return response.data.data;
  }
);
 

const stepTrackerSlice = createSlice({
  name: 'stepTracker',
  initialState: {
    steps: [],
    currentWeekAverage: 0,
    loading: false,
    errorMessage: '',
    stepData: null,
    averageStepsData: [], 
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStepTrackerData.pending, (state) => {
        state.errorMessage = '';
      })
      .addCase(fetchStepTrackerData.fulfilled, (state, action) => {
        state.steps = action.payload.steps;
        state.currentWeekAverage = action.payload.current_week_average;
        state.loading = false;
      })
      .addCase(fetchStepTrackerData.rejected, (state, action) => {
        state.errorMessage = action.error.message;
      })
      .addCase(deleteStepEntry.fulfilled, (state, action) => {
        // Remove the deleted entry from the state
        state.steps = state.steps.filter(step => step.id !== action.payload.id);
      })

      .addCase(addStep.fulfilled, (state, action) => {
        state.loading = false;
        state.stepData = action.payload;
      })
      .addCase(addStep.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAverageStepsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAverageStepsData.fulfilled, (state, action) => {
        state.averageStepsData = action.payload; 
        state.loading = false;
      })
      .addCase(fetchAverageStepsData.rejected, (state, action) => {
        state.errorMessage = action.error.message;
        state.loading = false;
      });
  },
});

export const { clearMessage } = stepTrackerSlice.actions;

export default stepTrackerSlice.reducer;